module.exports = __webpack_public_path__ + "img/img_safety_img5.1e13de2d.png";